import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spin } from "antd";
import { fetchLatestInsights } from "../store/slices/insightSlice";
import "../styles/latest-insights.css";

const imageMap = {
  "Experience": "/latestimg4.jpg",
  "Insight": "/latestimg1.jpg",
  "Innovate": "/latestimg3.jpg",
  "Accelerate": "/latestimg2.jpg",
  "Assure": "/beyondimg.jpg",
  default: [
    "/latestimg4.jpg",
    "/latestimg3.jpg",
    "/mostimg3.jpg",  

    "/mostimg2.jpg",  
    // "/beyondimg.jpg",
    "/mostimg1.jpg",
  ],
};

const fallbackInsights = [
  {
    id: "experience",
    tag: "Experience",
    title: "Transform with design.",
    description: "How design thinking and HumanOS are redefining workplace experiences and productivity.",
    image_url: "/latestimg4.jpg",
    size: "large",
  },
  {
    id: "insight",
    tag: "Insight",
    title: "Achieve 100x impact.",
    description: "How AI-driven talent strategies empower organizations to scale faster and smarter.",
    image_url: "/latestimg1.jpg",
  },
  {
    id: "innovate",
    tag: "Innovate",
    title: "Unite physical & digital.",
    description: "Why hybrid-first solutions and top talent are key to building sustainable business growth.",
    image_url: "/latestimg3.jpg",
  },
  {
    id: "accelerate",
    tag: "Accelerate",
    title: "Strengthen your core.",
    description: "Innovate confidently with scalable tech frameworks that strengthen your business foundation.",
    image_url: "/latestimg2.jpg",
  },
  {
    id: "assure",
    tag: "Assure",
    title: "Trust in the digital era.",
    description: "Building transparency, security, and accountability to strengthen customer confidence.",
    image_url: "/beyondimg.jpg",
  },
];

const getImageUrl = (insight, index) => {
  return imageMap.default[index % imageMap.default.length];
};

export default function LatestInsights() {
  const dispatch = useDispatch();
  const { latest, loading } = useSelector((state) => state.insights);

  useEffect(() => {
    dispatch(fetchLatestInsights());
  }, [dispatch]);

  const insights = useMemo(() => {
    if (latest.length > 0) {
      return latest.map((insight, index) => ({
        ...insight,
        image_url: getImageUrl(insight, index),
        size: insight.size || "normal",
      }));
    }
    return fallbackInsights;
  }, [latest]);

  return (
    <section id="latest-insights" className="latest-section scroll-mt-24">
      <div className="container latest-container">
        <div className="text-center mb-4 mb-md-5">
          <h2 className="latest-heading">
            <span>Latest</span> insights
          </h2>
          <p className="latest-subheading">
            Check out the latest news and find out what's happening at Ampstek...
          </p>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <Spin size="large" />
          </div>
        ) : (
          <div className="latest-tiles-grid">
            {insights.map((tile, index) => {
              let gridClass = "";
              let gridStyle = { backgroundImage: `url(${tile.image_url})` };
              
              if (index === 0) {
                gridClass = "latest-tile--large";
              } else if (index === 1) {
                gridClass = "latest-tile--pos-2";
              } else if (index === 2) {
                gridClass = "latest-tile--pos-3";
              } else if (index === 3) {
                gridClass = "latest-tile--pos-4";
              } else if (index === 4) {
                gridClass = "latest-tile--pos-5";
              }
              
              return (
              <article
                key={tile.id || `insight-${index}`}
                tabIndex={0}
                className={`latest-tile ${gridClass}`}
                style={gridStyle}
              >
                <div className="latest-tile-overlay">
                  <h3 className="latest-tile-title">{tile.title}</h3>
                  {tile.tag && (
                    <span className="latest-tile-tag">{tile.tag}</span>
                  )}
                  {tile.description && (
                    <p className="latest-tile-desc">{tile.description}</p>
                  )}
                </div>
              </article>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}
